import React from 'react';
import PropTypes from 'prop-types';
import { CODE_CATEGORIES } from '../../constants/api';
import { useApiAutocomplete } from '../../hooks/useApiAutocomplete';
import { application } from '../../services/application';
import { formatToTitleCase } from '../../utils/helpers';
import Autocomplete from '../common/Inputs/Autocomplete';

export const SinAutocomplete = (props) => {
  const { onChange, value, multi, labelKey = 'value', label, ...rest } = props;

  const { options, loading, handleValueChange, filterOptions, handleInputChange } = useApiAutocomplete({
    labelKey,
    onChange: React.useCallback((val) => onChange?.(val), [onChange]),
    getOptionList: (params) => application.call(CODE_CATEGORIES.GET_LIST_SIN_AUTOCOMPLETE, params),
  });

  const validateValueArray = () => {
    if (!multi) return value;
    if (Array.isArray(value)) {
      return value;
    }
    return [];
  };

  return (
    <Autocomplete
      name="gsa-sin"
      options={options}
      label={label}
      labelKey={labelKey}
      loading={loading}
      value={validateValueArray()}
      filterOptions={filterOptions}
      onChange={handleValueChange}
      multiple={multi}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      freeSolo
      formatLabelCB={formatToTitleCase}
      onInputChange={handleInputChange}
      getOptionSelected={(option, val) => (option?.id ? option?.id === (val?.id || val) : option === val)}
      {...rest}
    />
  );
};

SinAutocomplete.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  multi: PropTypes.bool,
  labelKey: PropTypes.string,
  label: PropTypes.string,
};
